export const CONTACT_LEVELS = {
  MANAGEMENT_COMPANY: 1,
  CUSTOMER: 2,
  BUILDING: 3,
  // Add other levels if necessary
};

export const contactName = [
  { key: "contactName", label: "Contact Name", required: true },
  { key: "contactTitle", label: "Title" },
];

export const contactLevelMap = [
  { key: 1, value: "Management" },
  { key: 2, value: "Customer" },
  { key: 3, value: "Building Site" },
];

export const description = [{ key: "description", label: "Description" }];

export const level = [
  { key: "contactLevel", label: "Level", options: contactLevelMap },
];

export const phoneFax = [
  { key: "phone1", label: "Phone Number", required: true },
  { key: "phone2", label: "Phone Number 2" },
  { key: "faxNumber", label: "Fax" },
];

export const secondaryPhone = [
  { key: "cellPhone", label: "Cell Phone" },
  { key: "cellPhone2", label: "Cell Phone 2" },
];

export const emailContact = [
  { key: "emailAddress", label: "Email", required: true },
  { key: "emailAddress2", label: "Email 2" },
];

export const defaultFormData = {
  contactName: "",
  emailAddress: "",
  phone1: "",
  phone2: "",
  faxNumber: "",
  description: "",
  contactTitle: "",
  cellPhone: "",
  cellPhone2: "",
  emailAddress2: "",
};
